module.exports = __webpack_public_path__ + "static/media/upp_flo_wor_pla.0d0f5ae4.png";